module.exports = {"TXTCLI_Remove":{"id":"TXTCLI_Remove","defaultMessage":"Entfernen","track":"Remove"}}